// react components
import React from 'react'
import {
    useSelector,
} from 'react-redux'

// components
import {
    AlertSite,
} from 'components'

// data
import {
    defaultReduxState,
} from 'data'

// props
type DeleteAlert825Props = {
    handleDelete: () => void
    objectName?: string
    setIsDeleteAlertOpen: React.Dispatch<boolean>
    setShowActionSheet?: any
}

// main
export const DeleteAlert825: React.FC<DeleteAlert825Props> = React.memo(({
    handleDelete,
    objectName,
    setIsDeleteAlertOpen,
    setShowActionSheet,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deleteAlertButtons = [
        {
            color: 'danger',
            handler: () => {
                handleDelete()
                if (setShowActionSheet) setShowActionSheet({ open: false, event: undefined })
            },
            text: reduxText[10208],
        },
        {
            text: reduxText[10209],
        },
    ]

    return (
        <AlertSite
            buttons={deleteAlertButtons}
            header={objectName ? `${reduxText[10210]}: "${objectName}" ?` : reduxText[10211]}
            isOpen
            message={reduxText[10212]}
            onDidDismiss={() => setIsDeleteAlertOpen(false)}
        />
    )
})
